import React from 'react';
import {
  QuickActionsContainer,
  QuickActionsTitle,
  QuickActionsGrid,
  QuickActionsBar,
  QuickActionButton,
} from '../styles';
import { UserCapabilities } from '../utils/dashboardTypes';
import { PlusIcon, UsersIcon, ShareIcon } from '../utils/iconMapping';

interface QuickActionsProps {
  capabilities: UserCapabilities;
  onAddRole: () => void;
  onAddCandidate: () => void;
  onInviteUser: () => void;
  onNavigate: (path: string) => void;
  horizontal?: boolean;
}

export function QuickActions({
  capabilities,
  onAddRole,
  onAddCandidate,
  onInviteUser,
  onNavigate,
  horizontal = false,
}: QuickActionsProps) {
  const actionButtons = (
    <>
      {capabilities.canAddRoles && (
        <QuickActionButton variant="default" onClick={onAddRole}>
          <PlusIcon />
          Add Role
        </QuickActionButton>
      )}
      {capabilities.canAddCandidates && (
        <QuickActionButton variant="default" onClick={onAddCandidate}>
          <PlusIcon />
          Add Candidate
        </QuickActionButton>
      )}
      <QuickActionButton variant="outline" onClick={() => onNavigate('/matches')}>
        <ShareIcon />
        View Matches
      </QuickActionButton>
      {capabilities.canInviteUsers && (
        <QuickActionButton variant="outline" onClick={onInviteUser}>
          <UsersIcon />
          Invite Collaborator
        </QuickActionButton>
      )}
    </>
  );

  if (horizontal) {
    return (
      <QuickActionsBar>
        <QuickActionsGrid horizontal={true}>
          {actionButtons}
        </QuickActionsGrid>
      </QuickActionsBar>
    );
  }

  return (
    <QuickActionsContainer>
      <QuickActionsTitle>Quick Actions</QuickActionsTitle>
      <QuickActionsGrid>
        {actionButtons}
      </QuickActionsGrid>
    </QuickActionsContainer>
  );
}
